import React, { useRef } from 'react';
import { useSettings } from '../SettingsProvider';
import { Form, FormControl, FormField, Switch } from '@ais-ui/ui-core';
import { BaseMapRemoveService } from './BaseMapRemove';
import { useBaseLayerConfigs } from './useBaseLayerConfigs';
import { useActivateBaseMapForm } from './useActivateBaseMapForm';
import { useBaseMapSnapshots } from './useBaseMapSnapShots';

export const BaseMapList = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const { settings } = useSettings();

  const { baseLayerConfigs, setBaseLayerConfigs } = useBaseLayerConfigs();

  const snapshots = useBaseMapSnapshots(baseLayerConfigs);

  const { form, onSubmit } = useActivateBaseMapForm();

  return (
    <div className="mt-4 grid gap-4">
      <div ref={mapRef} style={{ display: 'none' }}></div>
      {baseLayerConfigs.map((config) => (
        <div
          key={config.id}
          className="relative grid grid-cols-[auto_1fr_auto] items-center gap-4 rounded-lg border border-gray-200 bg-white px-4 py-6 dark:border-gray-800 dark:bg-gray-950"
        >
          {config.type !== 'osm' && config.type !== 's57' && (
            <BaseMapRemoveService
              baseLayerConfig={config}
              setBaseLayerConfigs={setBaseLayerConfigs}
              className="absolute top-1 right-1"
            ></BaseMapRemoveService>
          )}

          <div className="flex flex-col space-y-4">
            <img
              alt={`${config.title} Preview`}
              className="rounded-md"
              height="80"
              src={snapshots[config.id] || '/Paper map-bro.png'}
              style={{
                aspectRatio: '120/80',
                objectFit: 'cover',
              }}
              width="120"
            />
          </div>

          <div className="flex justify-between items-center">
            <div>
              <h3 className="font-medium">{config.title}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {config.description}
              </p>
            </div>
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className="space-y-8 mr-4"
              >
                <FormField
                  control={form.control}
                  name="active_base_map"
                  render={({ field }) => (
                    <FormControl>
                      <Switch
                        id={`base-map-switch-${config.id}`} // Add a unique id for each base map
                        checked={
                          settings['ribbonPlugin.settings'].active_base_map ===
                          config.id
                        }
                        onCheckedChange={(value) => {
                          const newValue = value ? config.id : '';
                          field.onChange(newValue);
                          form.handleSubmit(onSubmit)();
                        }}
                      />
                    </FormControl>
                  )}
                />
              </form>
            </Form>
          </div>
        </div>
      ))}
    </div>
  );
};
